import React, { useState } from 'react';
import GET_OFFER from '../../../graphql/GET_OFFER';
import ADD_SERVICE_LOG from '../../../graphql/ADD_SERVICE_LOG';
import { useQuery, useMutation } from '@apollo/client';
import styles from './QuickLinks.css.js';
import Radium from 'radium';
import LinkButton from './LinkButton';
import CustomInputForm from '../../CustomInputForm';
import LegalTerms from '../../LegalTerms';
import Skeleton from '@material-ui/lab/Skeleton';

const QuickLinks = ({ tracking }) => {
    const [ offerFound, setStateOffer ] = useState(null);
    const [ optOut, setOptOut ] = useState(false);

    const [ addTagToServiceLog ] = useMutation(ADD_SERVICE_LOG, { onCompleted: (data, error) => {
        if(error) {
            console.log('error during service log post:', error);
        } else {
            console.log(data.addServiceLog.message);
        }
    }});
    
    const handleOfferFound = data => {
        if(data) {
            const offer = data.fetchOfferFromFlow.body;
            setStateOffer(offer);
            addTagToServiceLog({ 
                variables: {
                    service: {
                        program_id: offer['program_id'],
                        group_id: offer['group_id'],
                        offer_id: offer['id'],
                        clickId: Number(tracking['HSID'])
                    }
                }
            });
		};
    };

    const handleOfferError = err => {
        console.error('Offer lookup: FAILED', err);
    };

    const { loading } = useQuery(GET_OFFER, {
        skip: !!offerFound || !tracking?.location,
        variables: {
            queryData: {
                auth_group: tracking.auth_group,
                pid: Number(tracking?.PID ?? 3317), 
                vertical: tracking?.VERTICAL ?? 'direct', 
                loan_type: tracking?.TYPE ?? 'gold_seal', 
                debt_type: 'N/A', 
                debt_amount: 'N/A'
            },
            user: { location: tracking?.location, clickId: Number(tracking?.HSID) }
        },
        onCompleted: handleOfferFound,
        onError: handleOfferError
    });

    const formStyle = Object.assign({},
        styles['formCard'],
        styles[tracking.theme]
    );

    return (
        (!loading && !!offerFound) ?
            <div style={styles.mainContainer}>
                <div style={formStyle}>
                    <div style={styles.titleText}>UnitedStatesCredit.com wants to know what you are interested in. Select One Below!</div>
                    <div style={styles.formContainer}>
                        {offerFound?.selection_links?.map((link, idx) => (
                            <LinkButton 
                                key={`link-button-${idx}`} 
                                link={{idx, ...link}}
                                tracking={tracking}
                                isOptOut={optOut}
                            />
                        ))}
                        {offerFound?.show_search && !!offerFound?.url ?
                            <CustomInputForm tracking={tracking} offer={offerFound} isOptOut={optOut}/> :
                            <LegalTerms 
                                email={tracking.EMAIL} 
                                isSearch={false} 
                                optOut={optOut} 
                                setOptOut={setOptOut}
                            />
                        }
                        {!!tracking.r &&
                            <div style={{ marginBottom: '15px' }}>
                                <a
                                    href={tracking.r}
                                    alt='next'
                                >
                                    <span style={styles.nextText}>None of the Above</span>
                                </a>
                            </div>
                        }
                    </div>
                </div>
            </div> :
            <div style={styles.loadingContainer}>
                <div style={formStyle}>
                    <div style={styles.titleText}>Finding your offers...</div>
                    {[1,2,3,4,5,6].map(count => (
                        <Skeleton
                            key={`skeleton-${count}`}
                            animation='wave'
                            width={500}
                            height={60}
                        />
                    ))}
                </div>
            </div>
    )
};

export default Radium(QuickLinks);